import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(public auth: AngularFireAuth) {
  }
  login(email: string, password: string) {
    return this.auth.signInWithEmailAndPassword(email, password);
  }
  signup(email: string, password: string) {
    return this.auth.createUserWithEmailAndPassword(email, password);
  }
  logout() {
    return this.auth.signOut();
  }
  hasUser() {

    return this.auth.authState;
  }
}
